import { usePaginatedQuery } from 'react-query';
import { listDemands } from 'src/services/api/demands';

function useListDemands(query, enabled = true) {
  return usePaginatedQuery(['demands', query], (key, query) => listDemands(query), { enabled });
}

export default useListDemands;
